import React, { useContext, useEffect } from "react";
import "./Popup.scss";
import { AppContext } from "../../stores/application.store";
const Popup = () => {
  const { popupValue, setPopupValue } = useContext(AppContext);
  useEffect(() => {
    // setPopupValue({ ...popupValue, text: "בדיקה", secondaryText: "בדיקה 2" });
  }, []);
  return (
    <div className={`popup ${popupValue.isShowing ? "" : "hidden"}`}>
      <div
        className="fade"
        onClick={() => {
          if (!popupValue.showLink) {
            setPopupValue({ ...popupValue, isShowing: false, showLink: false });
          }
        }}
      ></div>
      <div className="textbox-wrapper">
        <div className="textbox">
          {!popupValue.showLink && (
            <div
              className="x-icon"
              onClick={() =>
                setPopupValue({
                  ...popupValue,
                  isShowing: false,
                  formDisabled: false,
                })
              }
            ></div>
          )}
          <h3>{popupValue.text}</h3>
          <h4>{popupValue.secondaryText}</h4>
          {popupValue.showLink && (
            <a href="https://www.ynet.co.il/economy/poalimdigital">
              היכנסו למתחם <span className="red">"מקפצה לדיגיטל"</span>
              <br />
              ותיהנו מתכנים שיעזרו לעסק שלכם לצמוח
              <span className="arrows">&gt;&gt;</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;
